const SUPABASE_URL = process.env.REACT_APP_SUPABASE_URL || '';
const ANON_KEY = process.env.REACT_APP_SUPABASE_PUBLISHABLE_KEY || '';

const getQuizData = async (id: string | undefined): Promise<Record<string, any> | null> => {
    if (!id) return null;

    try {
        const data = await fetch(`${SUPABASE_URL}/rest/v1/funnels?name=eq.${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                apiKey: ANON_KEY,
            },
        });

        return data.json();
    } catch {
        return null;
    }
};

export default getQuizData;
